module.exports = __webpack_public_path__ + "static/media/verify-email.23c4a0cc.png";